import React from "react";
import { ArrowLeft, Pencil, Trash2, Save, Loader2 } from "lucide-react";

/**
 * Bandeau de fiche standard :
 * [← Retour] [Titre + badge statut + sous-titre] ————— [Modifier] [Supprimer]
 * En mode édition : [Annuler] [Enregistrer] au même endroit.
 */
export default function FicheHeader({
  onBack, backLabel = "Retour", title, subtitle, badge = null,
  editing = false, onEdit, onCancel, onSave, saving = false,
  onDelete, deleteLabel = "Supprimer", actions = null, testid = "fiche-header",
}) {
  return (
    <div data-testid={testid}>
      {onBack && (
        <button
          onClick={onBack}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-violet-700 transition-colors mb-4"
          data-testid="fiche-back-btn"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> {backLabel}
        </button>
      )}
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4">
        <div className="min-w-0">
          {badge}
          <h1 className="font-heading text-2xl sm:text-3xl font-medium tracking-tight text-slate-900 mt-1.5 break-words" data-testid="fiche-title">{title}</h1>
          {subtitle && <div className="text-sm text-slate-500 mt-1">{subtitle}</div>}
        </div>
        <div className="flex items-center gap-2 shrink-0 self-start" data-testid="fiche-actions">
          {actions}
          {editing ? (
            <>
              <button
                onClick={onCancel}
                className="h-10 px-4 rounded-xl border border-slate-200 text-sm font-medium text-slate-600 hover:bg-slate-50 transition-colors"
                data-testid="fiche-cancel-btn"
              >
                Annuler
              </button>
              <button
                onClick={onSave}
                disabled={saving}
                className="h-10 px-4 rounded-xl bg-violet-600 text-white text-sm font-semibold hover:bg-violet-500 transition-colors disabled:opacity-50 inline-flex items-center gap-2"
                data-testid="fiche-save-btn"
              >
                {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Enregistrer
              </button>
            </>
          ) : (
            <>
              {onEdit && (
                <button
                  onClick={onEdit}
                  className="h-10 px-4 rounded-xl border border-slate-200 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors inline-flex items-center gap-2"
                  data-testid="fiche-edit-btn"
                >
                  <Pencil className="h-3.5 w-3.5" /> Modifier
                </button>
              )}
              {onDelete && (
                <button
                  onClick={onDelete}
                  className="h-10 px-4 rounded-xl border border-red-200 text-sm font-medium text-red-600 hover:bg-red-50 transition-colors inline-flex items-center gap-2"
                  data-testid="fiche-delete-btn"
                >
                  <Trash2 className="h-3.5 w-3.5" /> {deleteLabel}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
